<div class="container-fluid">
  <h1 mat-dialog-title i18n>Import Item Quantity</h1>
  <div *ngIf="!fileSelected" mat-dialog-content>
    <h5 class="mt-5" i18n>Select a file then Click "Import File" to import item quantity data.</h5>
    <form #importForm="ngForm" (ngSubmit)="importItemQty()" class="container">
      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="workOrderSqrFt" i18n>File:</label>
            <app-file-upload [(fileBytes)]="fileBytes" [(importFile)]="importFile" 
                             accept=".csv, .xlsx, text/csv, application/openxmlformats-officedocument.spreadsheetml.sheet"></app-file-upload>
          </div>
          <div *ngIf="errors" class="mt-3 alert alert-danger">
            {{ errors }}
          </div>
        </div>
      </div>
      <div *ngIf="!isRequesting">
        <button type="submit" mat-button class="btn btn-bidit-action mr-1" i18n>Import File</button>
        <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </form>
  </div>

  <div *ngIf="this.importComplete" class="card bg-light">
    <div class="card-body">
      <h5 i18n>Item Qty Import - Failures</h5>
      <button type="button" (click)="exportErrors()" mat-button class="float-end btn btn-bidit-action mr-1" i18n>Export</button>

      <h6 class="mt-5" i18n>Review the failed import data below.  To make corrections click 'Export' make changes and re-import</h6>
      <div class="mat-table-scroll">
        <mat-table class="table table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource">
          <ng-container matColumnDef="itemDesc">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Item Description</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              {{itemQtyImport.itemQtyImport_Item_Desc}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="rValue">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>R-Value</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              <div fxLayout="column">
                <div>
                  {{itemQtyImport.itemQtyImport_RValue}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="itemTypeDesc">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Item Type</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              <div fxLayout="column">
                {{itemQtyImport.itemQtyImport_ItemTypeDesc}}
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Cost</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              <div fxLayout="column">
                <div *ngIf="itemQtyImport.itemQtyImport_Cost">
                  {{itemQtyImport.itemQtyImport_Cost}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="mfrPart">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Mfr Part#</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              <div fxLayout="column">
                <div *ngIf="itemQtyImport.itemQtyImport_Item_IDIPart">
                  {{itemQtyImport.itemQtyImport_Item_IDIPart}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="itemQty">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>QTY</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              <div fxLayout="column">
                <div *ngIf="itemQtyImport.itemQtyImport_Qty">
                  {{itemQtyImport.itemQtyImport_Qty}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="itemMessage">
            <mat-header-cell *matHeaderCellDef class="bidit-header" i18n>Error</mat-header-cell>
            <mat-cell *matCellDef="let itemQtyImport">
              <div fxLayout="column">
                <div *ngIf="itemQtyImport.itemQtyImport_Message">
                  {{itemQtyImport.itemQtyImport_Message}}
                </div>
              </div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns">
          </mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
